// extracted by mini-css-extract-plugin
export default {"price":"Price_price__4JoZD"};